var _circle, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartPlanetBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1427,
    height: 373,
    viewBox: "0 0 1427 373",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "startPlanet"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 4",
    style: {
      mixBlendMode: "overlay"
    },
    filter: "url(#filter0_f_2126_17462)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 713.5,
    cy: 713.5,
    r: 560.5,
    fill: "url(#paint0_linear_2126_17462)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 8",
    style: {
      mixBlendMode: "plus-lighter"
    },
    filter: "url(#filter1_f_2126_17462)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1233.35 456.501C1268.15 524.769 1289.17 599.223 1295.19 675.612C1301.22 752.001 1292.14 828.829 1268.47 901.709C1244.81 974.589 1207.02 1042.09 1157.27 1100.37C1107.51 1158.65 1046.77 1206.55 978.499 1241.35C910.231 1276.15 835.777 1297.17 759.388 1303.19C682.999 1309.22 606.171 1300.14 533.291 1276.47C460.411 1252.81 392.905 1215.02 334.629 1165.27C276.353 1115.51 228.447 1054.77 193.647 986.499C158.846 918.231 137.833 843.777 131.807 767.388C125.781 690.999 134.86 614.171 158.525 541.291C182.191 468.41 219.979 400.905 269.733 342.629C319.487 284.352 380.233 236.447 448.501 201.646C516.769 166.846 591.223 145.833 667.612 139.807C744.001 133.781 820.829 142.86 893.709 166.525C966.59 190.191 1034.1 227.979 1092.37 277.733C1150.65 327.488 1198.55 388.233 1233.35 456.501L1233.35 456.501Z",
    stroke: "url(#paint1_linear_2126_17462)",
    strokeWidth: 8
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 7",
    style: {
      mixBlendMode: "plus-lighter"
    },
    filter: "url(#filter2_f_2126_17462)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1233.35 456.501C1268.15 524.769 1289.17 599.223 1295.19 675.612C1301.22 752.001 1292.14 828.829 1268.47 901.709C1244.81 974.589 1207.02 1042.09 1157.27 1100.37C1107.51 1158.65 1046.77 1206.55 978.499 1241.35C910.231 1276.15 835.777 1297.17 759.388 1303.19C682.999 1309.22 606.171 1300.14 533.291 1276.47C460.411 1252.81 392.905 1215.02 334.629 1165.27C276.353 1115.51 228.447 1054.77 193.647 986.499C158.846 918.231 137.833 843.777 131.807 767.388C125.781 690.999 134.86 614.171 158.525 541.291C182.191 468.41 219.979 400.905 269.733 342.629C319.487 284.352 380.233 236.447 448.501 201.646C516.769 166.846 591.223 145.833 667.612 139.807C744.001 133.781 820.829 142.86 893.709 166.525C966.59 190.191 1034.1 227.979 1092.37 277.733C1150.65 327.488 1198.55 388.233 1233.35 456.501L1233.35 456.501Z",
    stroke: "url(#paint2_linear_2126_17462)",
    strokeWidth: 8
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 6",
    style: {
      mixBlendMode: "plus-lighter"
    },
    filter: "url(#filter3_f_2126_17462)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1233.35 456.501C1268.15 524.769 1289.17 599.223 1295.19 675.612C1301.22 752.001 1292.14 828.829 1268.47 901.709C1244.81 974.589 1207.02 1042.09 1157.27 1100.37C1107.51 1158.65 1046.77 1206.55 978.499 1241.35C910.231 1276.15 835.777 1297.17 759.388 1303.19C682.999 1309.22 606.171 1300.14 533.291 1276.47C460.411 1252.81 392.905 1215.02 334.629 1165.27C276.353 1115.51 228.447 1054.77 193.647 986.499C158.846 918.231 137.833 843.777 131.807 767.388C125.781 690.999 134.86 614.171 158.525 541.291C182.191 468.41 219.979 400.905 269.733 342.629C319.487 284.352 380.233 236.447 448.501 201.646C516.769 166.846 591.223 145.833 667.612 139.807C744.001 133.781 820.829 142.86 893.709 166.525C966.59 190.191 1034.1 227.979 1092.37 277.733C1150.65 327.488 1198.55 388.233 1233.35 456.501L1233.35 456.501Z",
    stroke: "url(#paint3_linear_2126_17462)",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 5",
    style: {
      mixBlendMode: "plus-lighter"
    },
    filter: "url(#filter4_f_2126_17462)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1233.35 456.501C1268.15 524.769 1289.17 599.223 1295.19 675.612C1301.22 752.001 1292.14 828.829 1268.47 901.709C1244.81 974.589 1207.02 1042.09 1157.27 1100.37C1107.51 1158.65 1046.77 1206.55 978.499 1241.35C910.231 1276.15 835.777 1297.17 759.388 1303.19C682.999 1309.22 606.171 1300.14 533.291 1276.47C460.411 1252.81 392.905 1215.02 334.629 1165.27C276.353 1115.51 228.447 1054.77 193.647 986.499C158.846 918.231 137.833 843.777 131.807 767.388C125.781 690.999 134.86 614.171 158.525 541.291C182.191 468.41 219.979 400.905 269.733 342.629C319.487 284.352 380.233 236.447 448.501 201.646C516.769 166.846 591.223 145.833 667.612 139.807C744.001 133.781 820.829 142.86 893.709 166.525C966.59 190.191 1034.1 227.979 1092.37 277.733C1150.65 327.488 1198.55 388.233 1233.35 456.501L1233.35 456.501Z",
    stroke: "url(#paint4_linear_2126_17462)",
    strokeWidth: 4
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2126_17462",
    x: 0.699997,
    y: 0.699997,
    width: 1425.6,
    height: 1425.6,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 76.15,
    result: "effect1_foregroundBlur_2126_17462"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2126_17462",
    x: 94,
    y: 102,
    width: 1239,
    height: 1239,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16,
    result: "effect1_foregroundBlur_2126_17462"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2126_17462",
    x: 118,
    y: 126,
    width: 1191,
    height: 1191,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_2126_17462"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_2126_17462",
    x: 124,
    y: 132,
    width: 1179,
    height: 1179,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2126_17462"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_2126_17462",
    x: 124,
    y: 132,
    width: 1179,
    height: 1179,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2126_17462"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2126_17462",
    x1: 713.5,
    y1: 153,
    x2: 713.5,
    y2: 1274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#080015",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#080015",
    stopOpacity: 0.04
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2126_17462",
    x1: 713.5,
    y1: 131.5,
    x2: 713.5,
    y2: 1305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#451E77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#451E77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2126_17462",
    x1: 713.5,
    y1: 131.5,
    x2: 713.5,
    y2: 1305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#451E77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.139,
    stopColor: "#451E77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2126_17462",
    x1: 713.5,
    y1: 131.5,
    x2: 713.5,
    y2: 1305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0389996,
    stopColor: "#B4A1FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2126_17462",
    x1: 713.5,
    y1: 131.5,
    x2: 713.5,
    y2: 1305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4A1FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0389996,
    stopColor: "#B4A1FC",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartPlanetBottom);
export default __webpack_public_path__ + "static/media/StartPlanetBottom.bb1dc3b4a4f7a64df99c4b3ca2d8322d.svg";
export { ForwardRef as ReactComponent };